import { isNativeShellApp } from '@/utils/appBridgeGate'

// 앱 네이티브 셸 인앱 웹뷰에서의 라우터 이동을 앱 브릿지로 위임.
// - window.__usimsaNativeHome : 웹 홈(/) 이동 → 네이티브 홈
// - window.__usimsaShellTab   : 임베드 탭의 페이지 이동 → 전체화면 새 창
// 2.2.6 이하에는 openNativeScreen / openWebPage 핸들러가 없어 abortNavigation 만
// 걸리고 아무 화면도 열리지 않으므로 게이트로 차단한다.
export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return
  if (!isNativeShellApp()) return

  // 웹 홈(/) 이동 → 네이티브 홈 탭 복귀
  if (window.__usimsaNativeHome && to.path === '/' && from.path !== '/') {
    window.flutter_inappwebview?.callHandler('openNativeScreen', {
      screen: 'home'
    })
    return abortNavigation()
  }

  // 임베드 탭에서의 그 외 페이지 이동 → 전체화면 새 창
  // 쿼리/해시만 변경되는 in-page 탭필터는 제외
  if (window.__usimsaShellTab && to.path !== from.path) {
    const url = new URL(to.fullPath, window.location.origin).href
    window.flutter_inappwebview?.callHandler('openWebPage', url)
    return abortNavigation()
  }
})
